
export const AlignLeft = ({color="#4E4B66", size=24}: {color?: string, size?: number}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.66602 18V6H7.76602V18H6.66602ZM8.86602 15V13.2H14.366V15H8.86602ZM8.86602 10.8V9H17.666V10.8H8.86602Z" fill={color}/>
    </svg>
  );
}